import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const monthRange = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  const last = new Date(y, m, 0).getDate();
  return { dal: `${ym}-01`, al: `${ym}-${String(last).padStart(2, "0")}` };
};

export const monthLabel = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return `${MESI[m - 1]} ${y}`;
};

const shift = (ym, n) => {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + n, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const MonthPicker = ({ value, onChange, testid = "month-picker" }) => (
  <div className="flex items-center gap-1 rounded-lg border border-slate-200 bg-white p-1 shadow-sm" data-testid={testid}>
    <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={() => onChange(shift(value, -1))} data-testid={`${testid}-prev`} aria-label="Mese precedente"><ChevronLeft className="h-4 w-4" /></Button>
    <label className="relative flex min-w-[150px] cursor-pointer items-center justify-center gap-2 px-2 text-sm font-semibold text-slate-800">
      <CalendarDays className="h-4 w-4 text-[#166534]" />
      <span data-testid={`${testid}-label`}>{monthLabel(value)}</span>
      <input type="month" value={value} onChange={(e) => { if (e.target.value) { onChange(e.target.value); } }}
        className="absolute inset-0 cursor-pointer opacity-0" data-testid={`${testid}-input`} aria-label="Scegli mese" />
    </label>
    <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={() => onChange(shift(value, 1))} data-testid={`${testid}-next`} aria-label="Mese successivo"><ChevronRight className="h-4 w-4" /></Button>
    {value !== currentMonth() && (
      <Button type="button" variant="ghost" size="sm" className="h-8 text-xs text-[#166534]" onClick={() => onChange(currentMonth())} data-testid={`${testid}-today`}>Mese corrente</Button>
    )}
  </div>
);
